export const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;
export const fbEvents = {
  addToCart: "AddToCart",
  addToWishList: "AddToWishlist",
  viewContent: "ViewContent",
  completeRegistration: "CompleteRegistration",
  contact: "Contact",
  initiateCheckout: "InitiateCheckout",
  purchase: "Purchase",
  search: "Search",
};

export const pageview = () => {
  if (!window?.fbq) return;

  window.fbq("track", "PageView");
};

export const sendFPixelEvent = (name, options = {}) => {
  window.fbq("track", name, options);
};

/**
 * View Content Event
 * Triggered when user views a product detail page
 */
export const viewItemEvent = (item) => {
  if (!window?.fbq) return;
  window.fbq("track","ViewContent", {
    items: [
      {
        item_id: [item.id || item.slug],
        item_name: item.name || "",
        price: item.price || 0,
        currency: "BDT",
        item_brand: item.brand?.name || "",
        item_category: Array.isArray(item.categories)
          ? item.categories.map((category) => category.name).join(", ")
          : "",        },
    ],
  });
};


/**
 * Sign in event
 * Trigger when user signin
 */

export const signInEvent = (method = "mobile") => {
  if (typeof window === "undefined" || !window.fbq) return;

  window.fbq("track", "sign_in", {
    content_name: "User Login",
    status: "success",
    method: method, // 'email' or 'mobile'
  });
};

/**
 * Sign Up Event
 * Triggered when a new user successfully completes registration
 */
export const signUpEvent = (method = "mobile") => {
  if (typeof window === "undefined" || !window.fbq) return;

  window.fbq("track", "CompleteRegistration", {
    content_name: "User Registration",
    status: "completed",
    method: method, // 'email', 'mobile',
  });
};


/**
 * Add to Cart Event
 * Triggered when user adds an item to cart
 */
export const addToCartEvent = (item, quantity = 1) => {
  if (typeof window === "undefined") return;
  if (window.fbq) {
    window.fbq("track", "AddToCart", {
      currency: "BDT",
      value: (item.price || 0) * (quantity || 1),
      items: [
        {
          item_id: [item.id || item.slug],
          item_name: item.name || "",
          price: item.price,
          quantity: quantity,
        },
      ],
    });
  }
};


export const checkoutEvent = (items, total, currency = "BDT") => {
  if (typeof window === "undefined") return;

  if (window.fbq) {
    window.fbq("track", "InitiateCheckout", {
      currency: currency,
      value: total,
      content_ids: items.map((item) => item.id || item.slug),
      contents: items.map((item) => ({
        id: item.id || item.slug,
        quantity: item.quantity || 1,
      })),
      content_type: "product",
      num_items: items.reduce((sum, item) => sum + (item.quantity || 1), 0),
    });
  }
};


/**
 * Purchase Event
 * Triggered when an order is successfully completed
 */
export const purchaseEvent = (
  transactionId,
  items,
  totalValue,
  currency = "BDT",
  affiliation = "Amarpet Store"
) => {
  if (typeof window === "undefined") return;

  if (window.fbq) {
    window.fbq("track", "Purchase", {
      content_ids: items.map((item) => item.id || item.slug),
      contents: items.map((item) => ({
        id: item.id || item.slug,
        quantity: item.quantity || 1,
        item_price: item.total || 0,
      })),
      content_type: "product",
      value: totalValue,
      currency: currency,
      num_items: items.reduce((sum, item) => sum + (item.quantity || 1), 0),
      transaction_id: transactionId,
      affiliation: affiliation,
    });
  }
};



